import { render, staticRenderFns } from "./MisMateriasnew.vue?vue&type=template&id=7db03fb3&scoped=true"
import script from "./MisMateriasnew.vue?vue&type=script&lang=js"
export * from "./MisMateriasnew.vue?vue&type=script&lang=js"
import style0 from "./MisMateriasnew.vue?vue&type=style&index=0&id=7db03fb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db03fb3",
  null
  
)

export default component.exports